// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"9cd24ef066dc79ba0743","293":"9233f7416fc286ebfd9e","518":"1aad43948bf8e115ae87","779":"3e2812ca463276ff9d86"}[chunkId] + ".js";
};